module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" " + _vm._s(_vm.item.label) + " ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.value),
      expression: "item.value"
    }],
    staticClass: "form-control margin-bottom",
    attrs: {
      "type": "checkbox",
      "placeholder": _vm.item.placeholder,
      "name": _vm.item.name,
      "disabled": _vm.item.disabled
    },
    domProps: {
      "checked": Array.isArray(_vm.item.value) ? _vm._i(_vm.item.value, null) > -1 : (_vm.item.value)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.item.value,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.item.value = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.item.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.item, "value", $$c)
        }
      }, _vm.update]
    }
  }), _vm._v(" "), _vm._l((_vm.item.errors), function(error) {
    return _c('div', {
      staticClass: "to-up",
      class: {
        'margin-left': _vm.item.type == 'checkbox'
      },
      attrs: {
        "id": "errors"
      }
    }, [_vm._v("\n        " + _vm._s(error) + "\n    ")])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d845980"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/input-components/emt-checkbox.vue
// module id = 95
// module chunks = 0